import { Col, Row } from 'antd';
import DonationDashboard from 'modules/dashboard/components/DonationDashboard';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const DonationDashboardPage: FC = () => {
  const { t } = useTranslation('dashboard.DashboardPage');

  return (
    <ProfileSideMenuWrapper title={t('donationDashboard')}>
      <Row gutter={[10, 10]} justify="space-between">
        <Col span={24}>
          <DonationDashboard />
        </Col>
      </Row>
    </ProfileSideMenuWrapper>
  );
};

export default DonationDashboardPage;
